import React, { useRef } from 'react';
import { createGlobalStyle } from 'styled-components';

import {
  getTokenFromUrl,
  TokenError,
  TokenErrorType,
  validateToken,
} from 'zdocs-web-core/lib/doc-editor';
import { TokenInfo } from 'zdocs-web-core/lib/token';
import BrandProvider from 'zdocs-web-core/components/BrandProvider';
import { ThemeType } from 'zdocs-web-core/theme/types';

import StandaloneEditor from './StandaloneEditor';
import ErrorPage, { ErrorPageType } from './ErrorPage';
import logger from 'zdocs-web-core/lib/logging/logger';
import { useState } from 'react';

const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  html, body {
    background-color: ${props => props.theme.constellation.colors.gray200}
  }
`;

function App() {
  const tokenInfo = useRef<TokenInfo | null>(null);
  const [errorPage, setErrorPage] = useState<ErrorPageType | null>(null);

  if (!tokenInfo.current) {
    try {
      tokenInfo.current = getTokenFromUrl();
      validateToken(tokenInfo.current);

      // At the moment we have no way to refresh the token, when it expires it expires.
      const remainingTime =
        tokenInfo.current.payload.exp * 1000 - new Date().getTime();
      setTimeout(() => {
        setErrorPage(ErrorPageType.Expired);
      }, remainingTime);
    } catch (e: unknown) {
      let nextErrorPage = ErrorPageType.Invalid;

      if (e instanceof TokenError) {
        switch (e.type) {
          case TokenErrorType.Expired:
            nextErrorPage = ErrorPageType.Expired;
            break;
          case TokenErrorType.Missing:
          case TokenErrorType.Invalid:
            nextErrorPage = ErrorPageType.Invalid;
            break;
          default:
            logger.error('Unknown error ocurred', e);
            nextErrorPage = ErrorPageType.Unknown;
        }
      }

      setErrorPage(nextErrorPage);
    }
  }

  function handleOnError() {
    setErrorPage(ErrorPageType.Unknown);
  }

  const errorPageProps = {
    type: errorPage,
    tokenInfo: tokenInfo.current,
  };

  return (
    <BrandProvider>
      <React.Fragment>
        <GlobalStyle />
        {errorPageProps.type !== null ? (
          <ErrorPage {...errorPageProps} />
        ) : !!tokenInfo.current ? (
          <StandaloneEditor
            token={tokenInfo.current.token}
            onError={handleOnError}
          />
        ) : null}
      </React.Fragment>
    </BrandProvider>
  );
}

export default App;
